// extracted by mini-css-extract-plugin
export default {"footer-social-links":"mAZF70It--FooterSocialLinks_footer-social-links__3Eg-R","footerSocialLinks":"mAZF70It--FooterSocialLinks_footer-social-links__3Eg-R"};